<template>
  <div class="notes">
    <div class="btnContainer">
      <v-btn color="primary" @click="addNewNote" text small>
        <v-icon class="mr-2">mdi-plus</v-icon>Add new note</v-btn
      >
    </div>
    <div v-if="isNotesExists" class="noteList">
      <div v-for="note in notes" :key="note.NotesId" class="note">
        <div class="header">
          <span class="mr-3">{{ getDateStr(note) }}</span>
        </div>
        <div class="noteBody">{{ note.Notes }}</div>
        <div class="actionBtn">
          <v-icon @click="editNote(note)" class="actionIcon">mdi-pencil</v-icon>
          <v-icon @click="deleteNote(note)" class="actionIcon">mdi-delete</v-icon>
        </div>
      </div>
    </div>

    <v-dialog v-if="note" v-model="dialog" :width="options.width" persistent>
      <v-card>
        <v-card-title class="text-h5 lighten-2">{{
          isNewNote ? 'New note' : 'Edit note'
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          <v-textarea solo name="note" label="Note" v-model="note.Notes"></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text @click="cancel"> Cancel </v-btn>
          <v-btn color="primary" @click="saveNote"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Utils from '@/utils.js';

export default {
  name: 'TransferNotes',
  props: {
    transfersInId: { type: Number },
  },
  created() {
    this.getNotes();
  },
  data: () => ({
    notes: [],
    note: null,
    loading: false,
    dialog: false,
    options: {
      width: 500,
    },
  }),
  methods: {
    addNewNote() {
      this.note = {
        MembershipId: this.memberId,
        TransferInId: this.transfersInId,
        NoteId: 0,
        Notes: null,
      };
      this.dialog = true;
    },
    editNote(existsNote) {
      this.note = {
        MembershipId: this.memberId,
        TransferInId: this.transfersInId,
        NoteId: existsNote.NotesId,
        Notes: existsNote.Notes,
      };
      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
      this.editingNote = null;
    },
    async getNotes() {
      this.loading = true;
      try {
        let response = await this.$api.get(
          '/TransfersIn/GetTransferNotes?membershipId=' +
            this.memberId +
            '&Id=' +
            this.transfersInId
        );

        this.notes = response.data;
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    },
    async saveNote() {
      try {
        await this.$api.post('/TransfersIn/SaveTransferNote', this.note);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Note was saved',
        });
        this.dialog = false;
        this.note = null;
        this.getNotes();
      } catch (err) {
        console.log(err.message);
      }
    },
    async deleteNote(existsNote) {
      try {
        await this.$api.delete('/TransfersIn/DeleteTranferNote?noteId=' + existsNote.NotesId);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Note was deleted',
        });
        this.getNotes();
      } catch (err) {
        console.log(err.message);
      }
    },
    getDateStr(existsNote) {
      if (existsNote) {
        const d = new Date(existsNote.DateEntered);
        return Utils.getDateStr(d);
      }

      return '-';
    },
  },
  computed: {
    memberId() {
      return this.$store.state.selectedMemberId;
    },
    isNewNote() {
      if (this.note && this.note.NoteId) return false;
      return true;
    },
    isNotesExists() {
      return this.notes && this.notes.length > 0;
    },
  },
  watch: {
    transfersInId: function () {
      this.getNotes();
    },
  },
};
</script>

<style lang="scss">
.notes {
  width: 100%;
  padding: 5px;

  .btnContainer {
    display: flex;
    justify-content: right;
  }

  .noteList {
    max-height: 150px;
    overflow-y: auto;
    padding: 5px 5px 5px 0px;

    .note {
      display: flex;
      background-color: aliceblue;
      border-radius: 6px;
      padding: 5px;
      margin-bottom: 5px;

      .header {
        flex-basis: 100px;
        flex-grow: 0;
        //display: flex;
        //justify-content: space-between;
      }

      .noteBody {
        flex-basis: 200px;
        flex-grow: 3;
      }

      .actionBtn {
        flex-basis: 50px;
        flex-grow: 0;

        .actionIcon {
          font-size: 1.2rem;
          vertical-align: top;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
